module.exports = __webpack_public_path__ + "img/plinth.6c0e9e19.svg";